import { useMutation } from '@tanstack/react-query';
import { downloader } from '@/shared/api';
import type { PrintShippingLabelsPayload } from '../model/types';

export function useDownloadShippingLabels() {
  return useMutation({
    mutationFn: async (payload: PrintShippingLabelsPayload) => {
      await downloader('/logistics/upaya/shipping-labels', {
        method: 'POST',
        data: payload,
        filename: 'shipping-labels.pdf',
        fallbackMime: 'application/pdf',
      });
    },
  });
}

export function useDownloadInvoicePdf() {
  return useMutation({
    mutationFn: async (docNumber: string) => {
      // docNumber commonly contains slashes (e.g. "UCC-SI/0002896/82-83");
      // URL-encode the path segment so axios doesn't split it into path parts.
      const encoded = encodeURIComponent(docNumber);
      // Filename keeps the original slashes converted to dashes so the
      // resulting download is a valid OS filename.
      const safeName = docNumber.replace(/\//g, '-');
      await downloader(`/logistics/upaya/invoices/${encoded}/pdf`, {
        filename: `invoice-${safeName}.pdf`,
        fallbackMime: 'application/pdf',
      });
    },
  });
}
